var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8335 12.0013L10.4049 8.0013M6.5954 8.0013L2.16685 12.0013M1.8335 4.66797L7.27678 8.47826C7.71756 8.78681 7.93795 8.94108 8.17767 9.00084C8.38943 9.05362 8.6109 9.05362 8.82265 9.00084C9.06238 8.94108 9.28277 8.78681 9.72355 8.47826L15.1668 4.66797M5.0335 13.3346H11.9668C13.0869 13.3346 13.647 13.3346 14.0748 13.1166C14.4511 12.9249 14.7571 12.6189 14.9488 12.2426C15.1668 11.8148 15.1668 11.2547 15.1668 10.1346V5.86797C15.1668 4.74786 15.1668 4.18781 14.9488 3.75999C14.7571 3.38366 14.4511 3.0777 14.0748 2.88596C13.647 2.66797 13.0869 2.66797 11.9668 2.66797H5.0335C3.91339 2.66797 3.35334 2.66797 2.92552 2.88596C2.54919 3.0777 2.24323 3.38366 2.05148 3.75999C1.8335 4.18781 1.8335 4.74786 1.8335 5.86797V10.1346C1.8335 11.2547 1.8335 11.8148 2.05148 12.2426C2.24323 12.6189 2.54919 12.9249 2.92552 13.1166C3.35334 13.3346 3.91339 13.3346 5.0335 13.3346Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b2dba7375d60a0f3db3a6616b6a43b28.svg";
export { ForwardRef as ReactComponent };